export default "__VITE_ASSET__C3al47kb__"